import { ValidateIf } from 'class-validator';
export function IsUndefinable(options) {
    return function IsUndefinableDecorator(prototype, propertyKey) {
        ValidateIf((obj) => undefined !== obj[propertyKey], options)(prototype, propertyKey);
    };
}
//# sourceMappingURL=IsUndefinable.js.map